import { useMemo } from 'react';

/**
 * Parses the current hostname to determine the active tenant/subdomain.
 *
 * Examples:
 *   analystbro.net       → { subdomain: null, isMainDomain: true }
 *   app.analystbro.net   → { subdomain: 'app', isMainDomain: false }
 *   pro.analystbro.net   → { subdomain: 'pro', isMainDomain: false }
 *   app.localhost        → { subdomain: 'app', isMainDomain: false }  (local dev)
 *   localhost            → { subdomain: null, isMainDomain: true }    (local dev)
 */
export function useTenant() {
  return useMemo(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // localhost or single-part hostname → main domain
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const hasSubdomain = !isLocalhost && parts.length > 2;
    const hasLocalhostSubdomain = hostname.endsWith('.localhost') && parts.length >= 2;

    let subdomain = null;
    if (hasSubdomain || hasLocalhostSubdomain) {
      subdomain = parts[0];
    }

    return {
      subdomain,
      isMainDomain: subdomain === null,
    };
  }, []);
}
